import { TextType, MetaType, TTS } from "../types"
import { actionCreatorGuard, reducerGuard, reducerActions } from "../reducers"

const kind = "block_texts"

export type BlockText = {
  kind: typeof kind
  version: number
  type: TextType
  text: string
  html: string
  draftjs: string
  deltas: any
  tts: TTS
  meta: MetaType
}

export const reducerAction = {
  meta: actionCreatorGuard<BlockText, MetaType>("meta", kind),
  type: actionCreatorGuard<BlockText, TextType>("type", kind),
  text: actionCreatorGuard<BlockText, string>("text", kind),
  html: actionCreatorGuard<BlockText, string>("html", kind),
  draftjs: actionCreatorGuard<BlockText, string>("html", kind),
  tts: actionCreatorGuard<BlockText, TTS>("tts", kind),
  deltas: actionCreatorGuard<BlockText, any>("deltas", kind)
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<
    BlockText,
    "kind" | "version"
  >]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const blockTextAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const blockTextReducer = reducerGuard<BlockText>(kind)
  .case(...reducerAction.meta)
  .case(...reducerAction.type)
  .case(...reducerAction.text)
  .case(...reducerAction.html)
  .case(...reducerAction.draftjs)
  .case(...reducerAction.deltas)
  .case(...reducerAction.tts)
  .build()
